import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { useParams } from 'react-router-dom';

const HIDE_LAYOUT_CLASS = 'hide-header-footer';

const InvitationPrintPreview = () => {
  const [data, setData] = useState(null);
  const previewRef = useRef(null);
  const [qrDataUrl, setQrDataUrl] = useState('');
  const { codeHash } = useParams();

  useEffect(() => {
    const stored = localStorage.getItem('invitationPreviewData');
    if (stored) setData(JSON.parse(stored));
    document.body.classList.add(HIDE_LAYOUT_CLASS);
    return () => {
      document.body.classList.remove(HIDE_LAYOUT_CLASS);
    };
  }, []);

  // QR kodunu PNG olarak al
  useEffect(() => {
    if (!data) return;
    setTimeout(() => {
      const qrCanvas = document.querySelector('#invitation-preview canvas');
      if (qrCanvas) {
        setQrDataUrl(qrCanvas.toDataURL('image/png'));
      }
    }, 200);
  }, [data]);

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPDF = async () => {
    const element = previewRef.current;
    if (!element) return;
    setTimeout(async () => {
      const canvas = await html2canvas(element, {
        scale: 5
      });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      // Dikeyde de ortala:
      const imgY = (pdfHeight - imgHeight * ratio) / 2;
      pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      pdf.save(data.title ? `${data.title}_davetiye.pdf` : 'davetiye.pdf');
    }, 500); // 500ms bekleme
  };

  if (!data) return null;

  return (
    <>
      <style>{`
        body.${HIDE_LAYOUT_CLASS} header, body.${HIDE_LAYOUT_CLASS} footer { display: none !important; }
        body.${HIDE_LAYOUT_CLASS} .Toastify { display: none !important; }
      `}</style>
      <Box
        ref={previewRef}
        id="invitation-preview"
        style={{
          backgroundColor: data.background_color,
          color: data.text_color,
          fontFamily: data.font_family,
          fontSize: `${data.font_size}px`,
          minHeight: '200px',
          border: `${data.border_width}px ${data.border_style} ${data.border_color}`,
          borderRadius: `${data.border_radius}px`,
          padding: `${data.padding}px`,
          textAlign: data.alignment,
          margin: '40px auto',
          width: 520, // Sabit ve PDF'ye uygun genişlik
          maxWidth: '100%',
          boxSizing: 'border-box'
        }}
      >
        <Typography variant="h5" gutterBottom style={{ fontFamily: data.font_family, color: data.text_color }}>
          {data.title}
        </Typography>
        <Typography style={{ whiteSpace: 'pre-wrap', fontFamily: data.font_family, color: data.text_color, fontSize: `${data.font_size}px` }}>
          {data.content}
        </Typography>
        <Box style={{ display: 'flex', justifyContent: 'center', marginTop: 24, pageBreakInside: 'avoid' }}>
          {qrDataUrl ? (
            <img src={qrDataUrl} alt="QR Code" style={{
              display: 'block',
              maxWidth: 200,
              backgroundColor: '#fff',
              border: '1px solid #f0f0f0',
              borderRadius: 4,
              padding: 10,
              margin: '10px auto'
            }} />
          ) : (
            <QRCodeCanvas
              value={window.location.origin + '/upload/' + (codeHash || '')}
              size={200}
              level="H"
              includeMargin={true}
              bgColor="#ffffff"
              fgColor="#000000"
            />
          )}
        </Box>
        <Typography style={{ marginTop: 24, textAlign: 'center', fontSize: 16, color: 'gray', fontFamily: 'Arial' }}>
          Anı SAKLA
        </Typography>
        <Typography style={{ textAlign: 'center', fontSize: 14, color: 'gray', fontFamily: 'Arial' }}>
        anisakla.com
        </Typography>
      </Box>
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2, '@media print': { display: 'none' } }}>
        <Button variant="contained" color="primary" onClick={handlePrint}>Yazdır</Button>
        <Button variant="contained" color="secondary" onClick={handleDownloadPDF}>PDF Olarak Kaydet</Button>
      </Stack>
    </>
  );
};

export default InvitationPrintPreview;